import Dropdown from 'lib/components/Dropdown/Dropdown'
import FilterDropdownTrigger from 'lib/components/FilterDropdownTrigger/FilterDropdownTrigger'
import { buildQueryString, QUERY_KEYS, QUERY_VALUES } from 'lib/util/routing'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import RecordedWebinarSort, { getDisplayNames } from '../RecordedWebinarSort'

export interface RecordedWebinarsSortDropdownProps {
  selectedSort: RecordedWebinarSort
}

export default function RecordedWebinarsSortDropdown(props: RecordedWebinarsSortDropdownProps) {
  const { selectedSort } = props
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const [t] = useTranslation()

  const displayName = getDisplayNames(t)
  const title = t('home.recordedWebinarsSection.sort.titleAttr', { sort: displayName[selectedSort] })

  return (
    <Dropdown>
      <FilterDropdownTrigger
        className="recorded-webinars-sort-dropdown__trigger"
        title={title}
        onClick={() => setIsOpen(true)}>
        {displayName[selectedSort]}
      </FilterDropdownTrigger>
      {isOpen && (
        <Dropdown.Menu flip={true} onRequestClose={() => setIsOpen(false)}>
          <Dropdown.MenuItem linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.sort, QUERY_VALUES.recent]]) } }}>
            {t('home.recordedWebinarsSection.sort.recent')}
          </Dropdown.MenuItem>
          <Dropdown.MenuItem
            linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.sort, QUERY_VALUES.popular]]) } }}>
            {t('home.recordedWebinarsSection.sort.popular')}
          </Dropdown.MenuItem>
          <Dropdown.MenuItem
            linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.sort, QUERY_VALUES.title]]) } }}>
            {t('home.recordedWebinarsSection.sort.title')}
          </Dropdown.MenuItem>
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
}
